import { render, staticRenderFns } from "./EditTelegram.vue?vue&type=template&id=580a987c&scoped=true&"
import script from "./EditTelegram.vue?vue&type=script&lang=js&"
export * from "./EditTelegram.vue?vue&type=script&lang=js&"
import style0 from "./EditTelegram.vue?vue&type=style&index=0&id=580a987c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a987c",
  null
  
)

export default component.exports